module.exports = __webpack_public_path__ + "static/media/ContasPagRec8.be2218f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec8.png
// module id = 2017
// module chunks = 0